import { FC } from 'react';
import { Button } from 'antd';

import { ModalComponent } from 'componets/common';
import { ModalProps, WPMenuUserNotice } from 'models';

interface NoticeModalProps extends ModalProps {
	item: WPMenuUserNotice;
}

export const NoticeModal: FC<NoticeModalProps> = ({ isOpen, onClose, item }) => {
	return (
		<ModalComponent isOpen={isOpen} onClose={onClose} title={item.title}>
			<div className="modal-content">
				<div dangerouslySetInnerHTML={{ __html: item.description }} />

				<div className="modal-footer">
					<Button onClick={onClose} type="primary">
						{item.button}
					</Button>
				</div>
			</div>
		</ModalComponent>
	);
};
